var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogleLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9168 7.14436C13.9168 6.72193 13.8785 6.32089 13.813 5.93054H7.6394V8.34214H11.1742C11.0157 9.13353 10.5514 9.80193 9.86297 10.2564V11.8606H11.9718C13.2065 10.743 13.9168 9.0961 13.9168 7.14436Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.63954 13.4168C9.40966 13.4168 10.8902 12.8393 11.972 11.8607L9.86311 10.2566C9.27308 10.6416 8.5246 10.8768 7.63954 10.8768C5.92953 10.8768 4.48175 9.74857 3.96273 8.22461H1.78833V9.8769C2.8646 11.973 5.07725 13.4168 7.63954 13.4168Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.96266 8.22461C3.82608 7.83961 3.75506 7.42787 3.75506 7.00009C3.75506 6.57232 3.83155 6.16058 3.96266 5.77558V4.12329H1.78826C1.34027 4.98954 1.0835 5.96273 1.0835 7.00009C1.0835 8.03746 1.34027 9.01065 1.78826 9.8769L3.96266 8.22461Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.63954 3.1233C8.60655 3.1233 9.46975 3.44949 10.1527 4.08581L12.0211 2.25706C10.8902 1.21969 9.40966 0.583374 7.63954 0.583374C5.07725 0.583374 2.8646 2.02713 1.78833 4.12324L3.96273 5.77553C4.48175 4.25157 5.92953 3.1233 7.63954 3.1233Z",
    fill: "#EA4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/GoogleLogo.f11fd627a181a3eb7039d5aebb36d098.svg";
export { ForwardRef as ReactComponent };